import { getStoreDomain } from './getStoreDomain';

export const URL_IMPLEMENTATIONS = {
  DOMAIN: 'domain',
  PATH: 'path',
};

export function getUrlImplementation() {
  const storeDomain = getStoreDomain(window.location.hostname);

  if (storeDomain) {
    return URL_IMPLEMENTATIONS.DOMAIN;
  }

  return URL_IMPLEMENTATIONS.PATH;
}
